export default {
  emptyState: {
    title: 'No returns yet',
    description: 'Returns issued against delivered orders will appear here.',
    filteredTitle: 'No returns matching your filters',
    filteredDescription: 'Try adjusting or clearing your filters to see more.',
  },
  errorState: {
    title: 'Unable to load returns',
    description: 'Something went wrong while loading. Please try again.',
  },
  contextMenu: {
    view: 'View return details',
    cancel: 'Cancel return',
    approve: 'Approve return',
    decline: 'Decline return',
  },
  noCreditRequests: 'There are currently no credit requests logged for this account.',
  filters: {
    search: 'Search by ID',
    site: 'Site',
    vendor: 'Vendor',
    status: 'Status',
    dateRange: 'Date range',
    createdBy: 'Created by',
  },
  tableHeaders: {
    id: 'ID',
    returnId: 'Return ID',
    status: 'Status',
    site: 'Site',
    vendor: 'Vendor',
    createdOn: 'Created on',
    createdBy: 'Created by',
    amount: 'Amount',
  },
  logReturn: {
    successToast: {
      title: 'Return issued',
      content: '{returnNumber} has been successfully issued',
    },
  },
  details: {
    title: 'Return',
    summary: {
      title: 'Return Summary',
      subtitle: 'Return Details, Vendor Details, Return Note',
      returnDetails: {
        title: 'Return Details',
        orderNumber: 'Order no.',
        siteName: 'Site name',
        type: 'Return type',
      },
      vendorDetails: {
        title: 'Vendor Details',
        vendorName: 'Vendor name',
        vendorEmail: 'Vendor email',
      },
      returnNote: 'Return Note',
      returnHistory: {
        title: 'Return History',
        requestedBy: 'Requested by',
        completedBy: 'Completed by',
        reviewedBy: 'Reviewed by',
        decline: 'decline',
        cancellation: 'cancellation',
        reasonForDeclineCancel: 'Reason for {type}',
      },
    },
    inventory: {
      title: 'Return Inventory',
      subtitle: 'Items included in this return',
      returnTotal: 'Return Total',
      totalInclVat: 'Total Incl VAT',
      returnItems: 'Return items',
      summaryTitle: 'Summary',
      vatTotal: 'VAT Total',
      vatNote: 'VAT registered vendors will have their VAT % added to their total price',
      pendingDelivery: 'Pending delivery',
      headers: {
        itemName: 'Item name',
        specification: 'Spec',
        deliveredOn: 'Delivered on',
        sku: 'SKU',
        ordered: 'Ordered',
        rate: 'Rate',
        returning: 'Returning',
        total: 'Total',
      },
    },
    documentation: {
      title: 'Documentation',
      subtitle: 'All documentation related to this request',
      toast: {
        uploadSuccess: {
          title: 'Document uploaded',
          content: 'The document has been successfully uploaded',
        },
        uploadError: {
          title: 'Error',
          content: 'An error occurred while uploading the document',
        },
      },
    },
    buttons: {
      cancel: 'Cancel return',
      approveReturn: 'Approve return',
      declineReturn: 'Decline return',
      cancelReturn: 'Cancel return',
    },
    approveModal: {
      title: 'Approve return',
      description: 'Are you sure you want to approve this return?',
      prAdjWarning:
        'This action will mark the return as Complete. After approval, it cannot be cancelled. Are you sure you want to proceed?',
    },
    declineCancelModal: {
      decline: 'Decline',
      cancel: 'Cancel',
      declining: 'declining',
      canceling: 'canceling',
      declined: 'declined',
      cancelled: 'cancelled',
      title: '{type} return',
      description: 'Please provide a reason for {type} this return',
      label: 'Reason',
      field: 'Write your reason here...',
    },
    toasts: {
      approveSuccess: {
        title: 'Return approved',
        content: 'Return has been successfully approved',
      },
      approveError: {
        title: 'Error approving return',
        content: 'An error occurred while approving the return',
      },
      declineCancelSuccess: {
        title: 'Return {type}',
        content: 'Return has been successfully {type}',
      },
      declineCancelError: {
        title: 'Error {type} return',
        content: 'An error occurred while {type} the return',
      },
    },
  },
};
